<template>
  <!--begin::Product Internal Listing-->
  <v-container fluid>

    <template v-if="type == 'engineer' && selectedRows.length > 0">
      <v-flex class="pt-0 justify-flex-end d-flex margin-auto">
        <h1 class="form-title selected-rows-text">
          {{ selectedRows.length }} Selected
        </h1>
        <v-spacer></v-spacer>
        <template v-if="getPermission('delivery:update')">
          <v-btn
            :disabled="dataLoading || hasDuplicateOrders"
            class="mx-2 custom-grey-border custom-bold-button mb-2"
            color="cyan white--text"
            v-on:click="confirm_dialog = true"
          >
            Update Order
          </v-btn>
        </template>
        <v-btn
          :disabled="dataLoading"
          class="mx-2 custom-grey-border custom-bold-button mb-2"
          color="red lighten-1 white--text"
          v-on:click="clearSelections"
        >
          <v-icon dark left>mdi-close</v-icon>Clear Selections
        </v-btn>
      </v-flex>
    </template>
    <template v-else>
      <v-flex class="pt-0 justify-flex-end d-flex my-2 mx-auto">
        
          <div class="d-flex align-center me-4" v-if="engineerId > 0">
          
           <v-chip color="green" label small  outlined style="padding: 10px!important; font-size:14px;">
                  <b>Total Trips on {{formatDate(tripsData?.date)}}: {{ tripsData.total }}</b>
            </v-chip>

             <v-chip color="orange" label small  outlined class="ml-2" style="padding: 10px!important;font-size:14px;">
                  <b>OT Trips on {{formatDate(tripsData?.date)}} : {{ tripsData.ot }}</b>
            </v-chip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                style="max-height:40px !important;"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="dataLoading"
                  class="mx-2 custom-bold-button"
                  color="cyan white--text"
                  @click="exportOT()"
                >
                  <v-icon dark left dense >mdi-database-export</v-icon> 
                </v-btn>
              </template>
              <span>Export OT Details</span>
            </v-tooltip>

          </div>

           <div class="d-flex align-center me-4" v-else>
          
           <v-chip color="green" label small  outlined style="padding: 10px!important; font-size:14px;" v-if="dates && dates[0] && dates[1]">
                  <b>Total Trips from {{formatDate(dates[0])}} to {{formatDate(dates[1])}}: {{ customerTripData.total }}</b>
            </v-chip>
             <v-chip color="green" label small  outlined style="padding: 10px!important; font-size:14px;" v-else>
                  <b>
                    Total Trips on {{ formatDate(customerTripData.date) }}: {{ customerTripData.total }}
                  </b>
            </v-chip>

          </div>
          <v-spacer ></v-spacer>

          <v-select
          v-if="type == 'customer'"
          style="max-width: 250px !important"
          :disabled="dataLoading"
          :loading="dataLoading"
          :items="fundingGroupList"
          v-model="funding_organisation"
          hide-details
          flat
          solo
          dense
          placeholder="Funding Organisation"
          color="cyan"
          item-color="cyan"
          class="pt-0 mt-0"
          item-text="text"
          item-value="text"
          clearable
          v-on:change="get_all_deliveries"
          v-on:click:clear="clearFilter('status')"
        >    
        </v-select>

       
        <v-text-field
          style="max-width: 250px !important"
          v-model.trim="search"
          v-on:click:clear="clearFilter('search')"
          clearable
          dense
          filled
          flat
          placeholder="Search"
          hide-details
          solo
          :disabled="dataLoading"
          :loading="dataLoading"
          color="cyan"
          @keydown.enter="get_all_deliveries"
          @keydown.tab="get_all_deliveries"
        ></v-text-field>
        <v-select
          style="max-width: 250px !important"
          :disabled="dataLoading"
          :loading="dataLoading"
          :items="statusList"
          v-model="status"
          hide-details
          flat
          solo
          dense
          placeholder="Status"
          color="cyan"
          item-color="cyan"
          class="pt-0 mt-0"
          item-text="text"
          item-value="status"
          clearable
          v-on:change="get_all_deliveries"
          v-on:click:clear="clearFilter('status')"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-avatar size="20">
                <v-chip :color="item.color" text-color=""> </v-chip>
              </v-avatar>
            </v-list-item-action>
          </template>
        </v-select>
         
        <div 
        style="width: 300px !important; min-width: 250px !important"
        >
         <DatePicker
            v-if="engineerId > 0"
            clearable 
            solo  
            flat
            :nullable="true"
            placeholder="Transport Date"
            v-model="date"
            v-on:change="get_all_deliveries"
           
          ></DatePicker>

          <v-menu
              v-else
              v-model="datePicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  filled
                  flat
                  label="Transport Date Range"
                  hide-details
                  solo
                  :loading="dataLoading"
                  :disabled="dataLoading"
                  v-on:click:clear="clearFilter('dates')"
                  clearable
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :value="formattedDate"
                  color="cyan"
                ></v-text-field>
              </template>
              <v-date-picker
                color="cyan"
                range
                :disabled="dataLoading"
                v-on:change="get_all_deliveries"
                v-model="dates"
              ></v-date-picker>
            </v-menu>
        </div>
        
      </v-flex>
    </template>
    <template v-if="selectedRows.length > 0">
              <v-flex class="pt-0 pb-2 justify-flex-between d-flex margin-auto">

                 <h1 class="form-title selected-rows-text">
                        {{ selectedRows.length }} Selected
                </h1>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="dataLoading"
                  class="ms-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  @click="convertToInvoice()"
                >
                  Convert to invoice
                </v-btn>
                <v-btn
                  :disabled="dataLoading"
                  class="ms-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-flex>
            </template>
    <ListingTable
      :column-count="columnCount"
      :data-loading="dataLoading"
      :row-data="dataRows"
    >
      <template v-slot:thead>
        <thead>
          <tr>
           <th class="simple-table-th" v-if="type== 'customer'">
           <v-checkbox
              dense
               v-model="allSelected"
               :indeterminate="isIndeterminate"
              color="cyan"
              hide-details
              >
            </v-checkbox>
           </th>
           <!-- <th class="simple-table-th" v-if="type == 'engineer'">
              Order Of Del.
            </th> -->
            <th class="simple-table-th">Transport #</th>
            <th class="simple-table-th">Title</th>
            <th class="simple-table-th" v-if="type== 'customer'">Active Funding Organisation</th>
            <!--   <th class="simple-table-th">Customer</th> -->
            <th class="simple-table-th">Transport Date</th>
            <th class="simple-table-th">Status</th>
            <th class="simple-table-th" v-if="type== 'engineer'">Driver Trip Count</th>
            <th class="simple-table-th" v-if="type== 'customer'">No. of Trips</th>
            <th class="simple-table-th">Assign To</th>
            <th class="simple-table-th">PDF</th>
            <!-- <th class="simple-table-th">Created Time</th> -->
          </tr>
        </thead>
      </template>
      <template v-slot:tbody>
        <tbody class="custom-border-bottom custom-border-top">
          <template v-if="dataRows.length">
            <template v-for="(row, index) in dataRows">
              <v-hover :key="index" v-slot="{ hover }">
                <tr class="alternate-listing-row" :key="index">
                 <td v-if="type== 'customer'" style="width: 30px !important">
                    <v-checkbox
                      dense
                      v-model="selectedRows"
                      v-bind:value="row"
                      color="cyan"
                      class="hide-margin"
                      hide-details
                      :disabled="row.qt_status_text === 'Failed' || row.qt_status_text === 'En-Route' || row.is_converted"
                    ></v-checkbox>
                  </td>
               <!--   <td v-if="type == 'engineer' && engineerId <= 0" style="width: 90px !important">
                    <v-text-field
                      v-if="selectedRows.includes(row)"
                      dense
                      filled
                      placeholder="Order"
                      v-model="row.order_no"
                      solo
                      flat
                      color="cyan"
                      :disabled="!selectedRows.includes(row)"
                      :error="isDuplicateOrder(row)"
                      @blur="validateOrderNo(row)"
                    />
                    <p class="m-0 custom-nowrap-ellipsis" v-else>
                      <v-chip
                        v-if="row.order_no"
                        class="font-weight-700"
                        small
                        color="black"
                        label
                        text-color=""
                        outlined
                      >
                        {{ row.order_no }}
                      </v-chip>
                    </p>
                    <em
                      v-if="!row.order_no && !selectedRows.includes(row)"
                      class="text-muted"
                    >
                      no order no</em
                    >
                  </td> -->
                 <td v-on:click="detailDelivery(row)">
                    <p class="m-0 custom-nowrap-ellipsis d-flex align-center">
                      <Barcode
                        small
                        :barcode="row?.barcode"
                        :id="row?.id"
                      ></Barcode>

                      <v-tooltip bottom v-if="row.is_converted">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            color="red darken-4"
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>

                        <span>
                          This trip is linked to a return trip - ensure no duplicate billing
                        </span>
                      </v-tooltip>
                    </p>
                </td>

                  <td v-on:click="detailDelivery(row)">
                    <div class="m-0 custom-nowrap-ellipsis d-flex">
                      <template v-if="row?.title">
                        <div class="my-auto ml-1">
                          <read-more
                            class="custom-read-more font-size-16 pb-1"
                            more-str="read more"
                            :text="row?.title || '<em>No Title</em>'"
                            link="#"
                            less-str="read less"
                            :max-chars="70"
                          >
                          </read-more>
                        </div>
                      </template>
                      <em class="text-muted" v-else> no title </em>
                    </div>
                  </td>

                  <td v-on:click="detailDelivery(row)" v-if="type== 'customer'">

                    <div class="m-0 custom-nowrap-ellipsis d-flex">
                      <template v-if="row.active_funding_group && row.active_funding_group.funding_organisation">
                        <div class="my-auto ml-1">
                          {{row.active_funding_group?.funding_organisation}}
                        </div>
                      </template>
                      <em class="text-muted" v-else> no active funding organisation </em>
                    </div>

                  </td>

                  <td v-on:click="detailDelivery(row)">

                    <div class="custom-nowrap-ellipsis">
                      <template v-if="row.qt_status_text === 'En-Route'">
                          <p class="m-0 custom-nowrap-ellipsis-two-line">
                            <b>Date: </b> -
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis-two-line">
                            <b>Time: </b> -
                          </p>
                      </template>

                      <template v-else>
                        <p class="m-0 custom-nowrap-ellipsis-two-line text-capitalize">
                          <b>Date: </b>
                          {{ formatDate(getRelevantDate(row)) }}
                        </p>

                        <p class="m-0 custom-nowrap-ellipsis-two-line text-capitalize">
                          <b>Time: </b>
                          <template v-if="showTimeRange(row)">
                              {{ formatDateTimeStart(row.started_at) }} -
                              {{ formatetimedata(row.finished_at) }}
                          </template>
                          <template v-else>
                            {{ formatDateTimeStart(getRelevantDate(row)) }}
                          </template>
                        </p>
                      </template>
                    </div>
                  </td>


                  <td v-on:click="detailDelivery(row)">
                    <div class="custom-nowrap-ellipsis">
                      <div class="mb-1 line-height-initial">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              class="my-auto custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                              :color="row.qt_status_color"
                              :text-color="row.qt_status_textcolor"
                              label
                              small="small"
                            >
                              <template
                                v-if="
                                  row?.status == 7 && row?.type == 'incoming'
                                "
                              >
                                Returned
                              </template>
                              <template
                                v-else-if="
                                  row?.status == 7 && row?.type == 'transfer'
                                "
                              >
                                Transferred
                              </template>
                              <template v-else>
                                {{ row.qt_status_text }}
                              </template>
                            </v-chip>
                          </template>
                          <span>Status</span>
                        </v-tooltip>
                      </div>
                      <div class="line-height-initial">
                        <v-chip
                          v-if="row?.is_exchange == 1"
                          label
                          :color="'red'"
                          class="my-auto"
                          small
                          outlined
                        >
                          Exchange
                        </v-chip>
                        <v-chip
                          v-if="row?.is_repair == 1"
                          label
                          :color="'red'"
                          class="my-auto"
                          small
                          outlined
                        >
                          Repair
                        </v-chip>
                      </div>
                      <CustomStatus
                        v-if="false"
                        small
                        :status="row?.status"
                        endpoint="delivery/status"
                      ></CustomStatus>
                    </div>
                  </td>

                   <td v-on:click="detailDelivery(row)" v-if="type== 'engineer'">
                    <div class="m-0 custom-nowrap-ellipsis d-flex">
                      <template v-if="row.driver_trip">
                          <b>{{ formatTrips(row.driver_trip) }}</b>
                      </template>
                      <em class="text-muted" v-else> 0 </em>
                    </div>
                  </td>

                   <td v-on:click="detailDelivery(row)" v-if="type== 'customer'">
                    <div class="m-0 custom-nowrap-ellipsis d-flex">
                      <template v-if="row.number_of_trips">
                          <b>{{ formatTrips(row.number_of_trips) }}</b>
                      </template>
                      <em class="text-muted" v-else> 0 </em>
                    </div>
                  </td>




                  <td v-on:click="detailDelivery(row)">
                    <div class="custom-nowrap-ellipsis">
                      <p
                        class="m-0 max-content-width text-truncate font-weight-700 text-capitalize"
                        :class="{
                          'text--secondary': lodash.isEmpty(
                            row.delivery_engineers
                          ),
                        }"
                      >
                        {{ engineerDisplayText(row.delivery_engineers) }}
                      </p>
                    </div>
                  </td>
                  <td class="simple-table-td">
                    <v-tooltip top content-class="custom-top-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!row.pdf_url"
                          color="red"
                          v-on:click.stop.prevent="downloadFile(row.pdf_url)"
                          >mdi-file-pdf</v-icon
                        >
                      </template>
                      <span>Download PDF</span>
                    </v-tooltip>
                  </td>
                  <td class="simple-table-td" v-if="false">
                    <TableActivity :data="row">
                      <template v-slot:date_time>
                        {{ formatDateTime(row?.added_at) }}
                      </template>
                      <template v-slot:format_date_time>
                        {{ formatDate(row?.added_at) }}
                        {{ formatTime(row?.added_at) }}
                      </template>
                    </TableActivity>
                  </td>
                </tr>
              </v-hover>
            </template>
          </template>
          <tr v-else>
            <td :colspan="columnCount">
              <p
                class="m-0 row-not-found text-center font-weight-500 font-size-16"
              >
                <img
                  :src="$assetURL('media/error/empty.png')"
                  class="row-not-found-image"
                />
                Uhh... There are no transport at the moment.
              </p>
            </td>
          </tr>
        </tbody>
      </template>
    </ListingTable>
    <ListingFooter
      :dataLoading="dataLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
      internal
    ></ListingFooter>
    <Dialog :common-dialog="confirm_dialog" :dialog-width="750">
      <template v-slot:title> Confirmation </template>
      <template v-slot:body>
        <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
          <v-container class="px-10" fluid>
            <p class="font-weight-600 font-size-19 text-center">
              Are you sure, you want to
              <span class="font-weight-700">update delivery orders</span>?
            </p>
          </v-container>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="confirm_loading"
          v-on:click="confirm_dialog = false"
          class="mx-2 custom-grey-border custom-bold-button"
        >
          No! Close
        </v-btn>
        <v-btn
          v-on:click="confirm_submit()"
          :disabled="confirm_loading"
          :loading="confirm_loading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
        >
          Yes! Continue
        </v-btn>
      </template>
    </Dialog>
  </v-container>
  <!--end::Product Internal Listing-->
</template>

<script>
import { QUERY, PATCH, GET } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import { ErrorEventBus } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import Barcode from "@/view/pages/partials/Barcode.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import moment from "moment";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import Dialog from "@/view/pages/partials/Dialog";
import AppConfiguration from "@/core/config/app.config";
import DatePicker from "@/view/components/DatePicker.vue";
import {
  SET_SELECTED_TRANSPORT, SET_FUNDING_ORGANISATION
} from "@/core/services/store/customer.module";

import JwtService from "@/core/services/jwt.service";
export default {
  mixins: [CommonMixin, FileManagerMixin, ValidationMixin],
  name: "equipment-internal-list",
  data() {
    return {
      parent: 0,
      warrantyDurationTypes: [
        { text: "Month(s)", value: "month" },
        { text: "Year(s)", value: "year" },
      ],
      dataRows: [],
      dates: [],
      totalPages: 0,
      paginationPageSize: 10,
      currentPage: 1,
      totalRows: 0,
      rowsOffset: 0,
      dataLoading: true,
      manage_brand: false,
      manage_location: false,
      form_loading: false,
      image_loading: false,
      selectedRows: [],
      date: null,
      status: null,
      search: null,
      statusList: [],
      funding_organisations : [],
      filter: {
        status: "all",
        search: null,
      },
      funding_organisation : null,
      fundingGroupList : [],
      timeoutLimit: 500,
      confirm_loading: false,
      confirm_dialog: false,
      bulkActions: [
        {
          title: "Convert to Invoice",
          icon:   "mdi-file-document",
          action: "invoice",
        },
       
      ],
    };
  },
  props: {
    type: {
      type: String,
      default: "customer",
    },
    equipmentId: {
      type: Number,
      default: 0,
    },
    customerId: {
      type: Number,
      default: 0,
    },
    saleId: {
      type: Number,
      default: 0,
    },
    rentalId: {
      type: Number,
      default: 0,
    },
    visitId: {
      type: Number,
      default: 0,
    },
    engineerId: {
      type: Number,
      default: 0,
    },
  },
  watch: {},
  components: {
    CustomStatus,
    TableActivity,
    Dialog,

    ListingFooter,
    ListingTable,
    Barcode,
    DatePicker,
    
  },
  methods: {

    getOptions() {
      const _this = this;
      _this.dataLoading = true;
      _this.$store
      .dispatch(GET, { url: "internal-delivery/funding-groups" })
      .then(({ data }) => {
      _this.fundingGroupList = data.funding_organisations;
    })
    .catch((error) => {
      _this.logError(error);
    })
    .finally(() => {
      _this.dataLoading = false;
    });
  },


     getRelevantDate(row) {
      switch (row.qt_status_text) {
        case 'Failed':
          return row.failed_at;
        case 'Transported':
          return row.completed_at;
        case 'En-Route':
          return null; 
        default:
          return row.started_at;
      }
  },
  showTimeRange(row) {

    return !['Failed', 'Transported', 'En-Route'].includes(row.qt_status_text);

  },

     formatTrips(value) {
      const num = parseFloat(value);
      return num % 1 === 0 ? num.toFixed(0) : num; 
    },
    confirm_submit() {
      if (this.selectedRows.length == 0) {
        return false;
      }
      const allOrderNoNull = this.selectedRows.every((row) => !row.order_no);

      if (allOrderNoNull) {
        ErrorEventBus.$emit("update:error", "Enter atleast one order no.");
        return;
      }

      this.confirm_loading = true;

      let payload = this.lodash.map(this.selectedRows, function (row) {
        return { id: row.id, order_no: row.order_no };
      });

      this.$store
        .dispatch(PATCH, {
          url: "delivery-order-update",
          data: { deliveryOrders: payload },
        })
        .then(() => {
          this.get_all_deliveries();
          this.confirm_loading = false;
          this.confirm_dialog = false;
          this.selectedRows = [];
        })
        .catch((error) => {
          this.logError(error);
          this.confirm_loading = false;
        })
        .finally(() => {
          this.confirm_loading = false;
        });
    },

     exportOT() {
    
      let downloadURL = process.env.VUE_APP_API_URL + "engineer/export-ot";
      downloadURL = new URL(downloadURL);

      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      this.lodash.map(this.queryParams, function (row, index) {
        downloadURL.searchParams.append(index, row);
      });

      downloadURL.searchParams.append("engineer_id", this.engineerId);
      downloadURL.searchParams.append("date", this.date);
      this.lodash.map(this.listingSearch, function (row, index) {

        if (index == "dates") {
          if (row && row[0]) {
            downloadURL.searchParams.append("dates[0]", row[0]);
          }
          if (row && row[1]) {
            downloadURL.searchParams.append("dates[1]", row[1]);
          }
        } else {
          downloadURL.searchParams.append(index, row);
        }

      });
      window.open(downloadURL, "_blank");

    },

  
    async convertToInvoice()
    {
      
       await this.getOngoingContract();

       const fundingGroupIds = this.funding_organisations.map(org => org.funding_group_id).filter(Boolean);

      

       const uniqueIds = [...new Set(fundingGroupIds)];

        console.log(fundingGroupIds);

      if (uniqueIds.length > 1) {
         ErrorEventBus.$emit("update:error", "Selected trips are funded by different organizations. Split the selection by Funding Organisation.");
        return;
      }

       const selectedFundingOrg = this.funding_organisations.find(
        org => org.funding_group_id === uniqueIds[0]
      );


      this.$store.commit(SET_SELECTED_TRANSPORT, this.selectedRows);
      this.$store.commit(SET_FUNDING_ORGANISATION, selectedFundingOrg);

      this.$router.push(
          this.getDefaultRoute("invoice.create"
          , {
            query: {
              customer : this.customerId,
            },
          })
      );	

    },


    getOngoingContract()
    {
     
      const _this = this;

      const selectedTransports = _this.selectedRows.map(row => row.id);

      let data = {
        dates : _this.dates,
        selected_transports : selectedTransports
      };

      _this.dataLoading = true;

      return  _this.$store
          .dispatch(QUERY, {
            url: "ongoing-contract" + '/' + this.customerId,
            data : data
          })
          .then(({ data }) => {
              this.funding_organisations = data;
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.dataLoading = false;
          });
  
    },

    isDuplicateOrder(currentRow) {
      if (!currentRow.order_no) {
        return false;
      }
      return this.dataRows.some(
        (row) =>
          row !== currentRow &&
          this.formatDate(row.started_at) ===
            this.formatDate(currentRow.started_at) &&
          row.order_no === currentRow.order_no
      );
    },
    validateOrderNo(row) {
      if (this.isDuplicateOrder(row)) {
        this.$set(row, "order_no", null);
      }
      /*  this.get_all_deliveries(); */
    },
    clearSelections() {
      this.selectedRows = [];
    },

    selectDate() {
     
      if (!this.lodash.isEmpty(this.date)) {
      const Config = AppConfiguration.get();
      if (Config) {
        return moment(this.date).format(Config.dateFormat);
      }
    }
      return null;
    },
    detailDelivery(data) {
      let routeName = null;
      if (data?.type == "incoming") {
        routeName = "incoming-delivery.detail";
      } else if (data?.type == "outgoing") {
        routeName = "outgoing-delivery.detail";
      } else if (data?.type == "transfer") {
        routeName = "transfer-delivery.detail";
      }
      this.$router.push(
        this.getDefaultRoute(routeName, {
          params: {
            id: data?.id,
          },
        })
      );
    },
    getColor(type) {
      if (type == "incoming") {
        return "incoming-color white--text";
      } else if (type == "outgoing") {
        return "outgoing-color white--text";
      } else if (type == "transfer") {
        return "transfer-color";
      }
    },
    getIcon(type) {
      if (type == "incoming") {
        return "mdi-transfer-down";
      } else if (type == "outgoing") {
        return "mdi-transfer-up";
      } else if (type == "transfer") {
        return "mdi-transfer";
      }
    },
    formatDateTimeStart(row) {
      return moment(row).format("hh:mm A");
    },
    formatetimedata(row) {
      //console.log(row,"row");
      return moment(row).format("hh:mm A");
    },

    clearFilter(field) {
      
      const _this = this;
      switch (field) {
        case "search":
          _this.search = null;
          break;
        case "date":
          _this.date = null;
          break;
        case "status":
          _this.status = null;
          break;
        case "dates":
          _this.dates = [];
          break;

        case "funding_organisation":
          _this.funding_organisation = null;
          break;
          

      }
      _this.get_all_deliveries();
    },
    engineerDisplayText(param) {
      const _this = this;
      let display_name = new Array();
      if (
        _this.lodash.isEmpty(param) === false &&
        _this.lodash.isArray(param)
      ) {
        display_name.push(param[0].display_name);
        if (param.length - 1) {
          const message = ` +${param.length - 1} more...`;
          display_name.push(message);
        }
      }
      if (_this.lodash.isEmpty(display_name)) {
        return "Not assigned.";
      } else {
        return display_name.join(", ");
      }
    },
    downloadFile(url, prepend_url) {
      if (!url) {
        return false;
      }
      if (prepend_url) {
        url = `https://bthrust-fsm.s3.ap-southeast-1.amazonaws.com/${url}`;
      }
      window.open(url, "_blank");
    },
    get_all_deliveries() {
      const _this = this;

      let filter = {
        status: this.status,
      /*   per_page: _this.paginationPageSize, */
        current_page: _this.currentPage,
        customer: this.customerId,
        rental: this.rentalId,
        sale: this.saleId,
        visit: this.visitId,
        engineer: this.engineerId,
        date: this.date,
        search: this.search,
        dates : this.dates,
        funding_organisation : this.funding_organisation

      };

      clearTimeout(_this.timeout);
      _this.dataRows = [];
      _this.dataLoading = true;
      _this.timeout = setTimeout(function () {
        _this.$store
          .dispatch(QUERY, {
            url: "internal/delivery",
            data: filter,
          })
          .then(({ data }) => {
            _this.dataRows = data.rows;
            _this.totalPages = Math.ceil(data.total_rows / data.per_page);
            _this.currentPage = data.current_page;
            _this.totalRows = data.total_rows;
            _this.rowsOffset = data.offset;
            _this.statusList = data.status_list;
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.dataLoading = false;
          });
      }, _this.timeoutLimit);
    },
  },
  mounted() {

    const _this = this;
    _this.getOptions();
    _this.get_all_deliveries();
    PaginationEventBus.$on("update:pagination", (param) => {
      _this.currentPage = param;
      _this.get_all_deliveries();
    });

    /*   _this.$nextTick(() => {
      _this.equipment.customer = _this.equipmentId;
    }); */
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 70);
    },

    allSelected: {

      get() {

        const transportedRows = this.dataRows.filter(row => row.qt_status_text !== 'Failed' && row.qt_status_text !== 'En-Route');

        const sel = this.selectedRows.length;
        const total = transportedRows.length;

        if (sel > 0 && sel < total) return true;
        return sel === total && total > 0;
      },

      set(value) {
        if (value) {
          this.selectedRows = this.dataRows.filter(row => row.qt_status_text !== 'Failed'
           && row.qt_status_text !== 'En-Route'
           && !row.is_converted
          );
        } else {
          this.selectedRows = [];
        }
      }
    },

     isIndeterminate() {
      const sel = this.selectedRows.length;
      const total = this.dataRows.length;
      return sel > 0 && sel < total;
    },

    tripsData() {

      const today = new Date().toISOString().split('T')[0]; 
     
      const filterDate = this.date || today;
      
      const total = this.dataRows.reduce((sum, row) => {
        
      const rowDate = new Date(row.started_at).toISOString().split('T')[0];
       
      if (rowDate === filterDate) {

        return sum + (parseFloat(row.driver_trip) || 0);
        
      }

      return sum;

    }, 0);


    const ot = total <= 6 ? 0 : total - 6;

    return {
      total: total,
      ot: ot,
      date: filterDate
    };
},

customerTripData() {

  const today = new Date().toISOString().split('T')[0];

  const hasDateRange = Array.isArray(this.dates) && this.dates[0] && this.dates[1];

  let total = 0;

   if (hasDateRange) {
      total = this.dataRows.reduce((sum, row) => {
      return sum + (parseFloat(row.number_of_trips) || 0);
    }, 0);
    } else {
  total = this.dataRows.reduce((sum, row) => {
    let filterDate;
      if (row.status === 7) {
        filterDate = row.completed_at;
      } else if (row.status === 2) {
      filterDate = row.failed_at;
      } else {
        filterDate = row.started_at;
      }

      const rowDate = new Date(filterDate).toISOString().split('T')[0];

      if (rowDate === today) {
        return sum + (parseFloat(row.number_of_trips) || 0);
      }
      return sum;
    }, 0);
}

  return {
    total,
     date: hasDateRange ? null : today
  };
  },

    columnCount() {
      let result = 9;
      return result;
    },
    showingFrom() {
      return this.lodash.isEmpty(this.dataRows) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return this.rowsOffset + (this.dataRows ? this.dataRows.length : 0);
    },
    show_order() {
      return this.selectedRows.length > 0 ? true : false;
    },
    hasDuplicateOrders() {
      const validOrders = this.dataRows
        .filter((row) => row.order_no)
        .map((row) => `${row.order_no}-${row.started_at}`);
      const uniqueOrders = new Set(validOrders);
      return uniqueOrders.size !== validOrders.length;
    },
  },
};
</script>
